import { render, staticRenderFns } from "./ToolbarProfileMenu.vue?vue&type=template&id=6b128e31&scoped=true"
import script from "./ToolbarProfileMenu.vue?vue&type=script&lang=js"
export * from "./ToolbarProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./ToolbarProfileMenu.vue?vue&type=style&index=0&id=6b128e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b128e31",
  null
  
)

export default component.exports